import { IXSModalComponent } from "./ixsmodal/ixsmodal.component";
import { Input } from "@angular/core";

export interface MapConfiguration {
  field: string;
  mapField: string;
}

export const Enum = {
  Mode: {
    Default: 0,
    New: 1,
    Display: 2,
    Edit: 3,
    None: 4
  },

  modalSize: {
    Large: "lg",
    Mediam: "md",
    Small: "sm"
  },
  modalType: {
    Normal: 1,
    Custom: 2,
  },
  ExportTypes: {
    Import: 1,
    Export: 2,
  }
};

export const GridType = {
  inputGrid: 0,
  readOnlyGrid: 1,
  selectionGrid: 2,
  actionsGrid: 3
};
export interface modalArgs {
  cancel: boolean;
  modal: IXSModalComponent;
  rowData: any;
}

export interface moodConfig {
  MoodGroup: string;
  moodId: any;
  moodValue: any;
  moodIcon: string;
}

export const addRow = {
  top: "top",
  current: "current",
  bottom: "bottom"
};
export const inputType = {
  text: "text",
  mobile: "mobile",
  phone: "phone",
  cnic: "cnic",
  license: "license",
  time: "time"
};

export interface customButton {
  name: string;
  caption: string;
  icon?: string;
  type?: CustomButtonType;
  valueMember?: string;
  displayMember?: string;
  dropDownData?: any;
  customButtons?: customButton[];
  value?: any;
  hideCaption?: boolean;
  placeHolder?: string;
  modal?: IXSModalComponent;
  disabled?: boolean;
  oldValue?:any;
}

export interface customButtonList {
  grpname?: string,
  name: string;
  caption: string;
  icon?: string;
}

export interface moodcustomList {
  grpname?: string,
  name: string;
  caption: string;
  icon?: string;
}

export interface titleConfig {
  fieldname: string;
  Caption: string;
  Image: string;
  Class: string;
  maxValue: string;
  percentvalue: string;
}

export const CustomButtonType = {
  Button: 0,
  Dropdown: 1,
  TextBox: 2,
  Number: 3,
  Checkbox: 4,
  Hide: 5,
  Date: 6,

};

export interface CustomButtonType { }

export const errorDisplayMode = {
  Modal: 1,
  Toaster: 2
};

export interface CustomButtonType { }

export interface customGridMenu {
  grpname?: string,
  name: string;
  caption: string;
  icon?: string;
}

export interface Operator { }

export const Operator = {
  None: 0,
  Sum: 1,
  Percent: 2,
  Formula: 3,
  Count: 4
};

export interface Condition { }

export const Condition = {
  Equal: 1,
  GreaterThen: 2,
  GreaterThenEqual: 3,
  LessThen: 4,
  LessThenEqual: 5
};

export interface summaryConfig {
  field: string;
  caption: string;
  type: Operator;
  value?: any;
  filterBy?: filterBy;
  AddFields?: filterBy[];
  SubFields?: filterBy[];
  percentBaseField?: string;
  percentValueField?: string;
  group?: string;
  editable?: boolean;
  summaryFieldName?:string;
  controltype?:number;
}

export interface filterBy {
  field: string;
  value: any;
  Condition: Condition;
}

 export  abstract class ControlBase {
   
   private _index:number = -1;
  @Input()
  get index(): any {
    return this._index;
  }

  set index(v: any) {
    this._index = v;
  }
    
}




// WEBPACK FOOTER //
// ./src/app/components/config.ts